import { Component, Vue } from "vue-property-decorator";
import {
  BASE_API_URL,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_API_PLACE_SEARCH_URL,
} from "../../utils/Constants";
import { queryParams } from "../../utils/Typography";

export const SEARCH_PLACE_TAG = "search_place";

@Component
export default class ConfirmationMixin extends Vue {
  validateToken(confirmationToken: string) {
    const path = "confirmation/validate";
    const param = queryParams({ confirmation_token: confirmationToken });
    return this.$httpGet(BASE_API_URL + path + "?" + param, "confirmation");
  }

  searchPlace(term: string) {
    const query = queryParams({
      inputtype: "textquery",
      language: "it",
      input: term,
      key: GOOGLE_MAPS_API_KEY,
    });
    return this.$httpGet(
      GOOGLE_MAPS_API_PLACE_SEARCH_URL + "?" + query,
      SEARCH_PLACE_TAG
    );
  }
}
